class ProductDetailDrawer extends HTMLElement {
  selectors = {
    open: '[data-js-detail-open]',
    externalOpen: '[data-js-need-help-open]',
    close: '[data-js-detail-close]',
    dialog: '[data-js-detail-dialog]'
  };

  stateClasses = {
    isOpen: 'is-open'
  };

  connectedCallback() {
    this.openButtonElement = this.querySelector(this.selectors.open);
    this.externalOpenElements = this.hasAttribute('data-need-help-drawer') ? document.querySelectorAll(this.selectors.externalOpen) : [];
    this.closeButtonElement = this.querySelector(this.selectors.close);
    this.dialogElement = this.querySelector(this.selectors.dialog);

    this.openButtonElement?.addEventListener('click', this.onOpen);
    this.externalOpenElements.forEach((element) => element.addEventListener('click', this.onOpen));
    this.closeButtonElement?.addEventListener('click', this.onClose);
    this.dialogElement?.addEventListener('click', this.onDialogClick);
    this.dialogElement?.addEventListener('cancel', this.onCancel);
    this.dialogElement?.addEventListener('transitionend', this.onTransitionEnd);
    document.addEventListener('shopify:block:select', this.onBlockSelect);
  }

  disconnectedCallback() {
    this.openButtonElement?.removeEventListener('click', this.onOpen);
    this.externalOpenElements.forEach((element) => element.removeEventListener('click', this.onOpen));
    this.closeButtonElement?.removeEventListener('click', this.onClose);
    this.dialogElement?.removeEventListener('click', this.onDialogClick);
    this.dialogElement?.removeEventListener('cancel', this.onCancel);
    this.dialogElement?.removeEventListener('transitionend', this.onTransitionEnd);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
    if (this.dialogElement?.open) this.dialogElement.close();
  }

  onOpen = (event) => {
    event?.preventDefault();
    if (!this.dialogElement.open) this.dialogElement.showModal();
    this.dialogElement.getBoundingClientRect();
    this.dialogElement.classList.add(this.stateClasses.isOpen);
  };

  onClose = () => {
    if (!this.dialogElement.classList.contains(this.stateClasses.isOpen)) {
      this.dialogElement.close();
      return;
    }
    this.dialogElement.classList.remove(this.stateClasses.isOpen);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.dialogElement.close();
    }
  };

  onDialogClick = (event) => {
    const bounds = this.dialogElement.getBoundingClientRect();
    if (event.target === this.dialogElement && event.clientX < bounds.left) this.onClose();
  };

  onCancel = (event) => {
    event.preventDefault();
    this.onClose();
  };

  onTransitionEnd = (event) => {
    if (event.target === this.dialogElement && event.propertyName === 'transform' && !this.dialogElement.classList.contains(this.stateClasses.isOpen)) {
      this.dialogElement.close();
    }
  };

  onBlockSelect = (event) => {
    if (event.detail.blockId === this.dataset.blockId) this.onOpen();
  };
}

if (!customElements.get('product-detail-drawer')) {
  customElements.define('product-detail-drawer', ProductDetailDrawer);
}
